import React from 'react'
import { t } from '@lingui/core/macro'
import moment from 'moment'
import * as css from './styled'

interface OutboundBatchSuccessItemProps {
  id: number
  remoteJobId: string
  updatedAt: string
  children: React.ReactNode
}

export const OutboundBatchSuccessItem = ({
  id,
  updatedAt,
  remoteJobId,
  children,
}: OutboundBatchSuccessItemProps) => (
  <css.Alert key={id}>
    {children}
    <css.Divider />
    <div>
      {t`Sync requested at:`}
      {moment(updatedAt).format('MM/DD/YY h:mm:ss a')}
    </div>
    {remoteJobId && (
      <>
        <css.Divider />
        <div>{t`Technical troubleshooting information here`}</div>
        <div>
          {t`Remote job ID:`}
          {remoteJobId}
        </div>
      </>
    )}
  </css.Alert>
)
